<template>
  <svg :width="size || width" :height="size || height">
    <use :xlink:href="`#${icon}`" />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      required: false,
      default: null
    },
    width: {
      required: false,
      default: 20
    },
    height: {
      required: false,
      default: 20
    },
    icon: {
      required: true,
      default: ''
    }
  }
}
</script>
